
export const PENDING_LAUNCH_ID_KEY = 'pending_launch_id'
export const LAUNCH_ID_KEY = 'launch_id'
export const PDPLUS_LIC_COMPLETED = 'pdplus_lic_completed'
export function getPendingLaunchId(): string | null {
  return sessionStorage.getItem(PENDING_LAUNCH_ID_KEY)
}